import React from 'react';
import { useIntl } from 'react-intl';
import NewsletterV2 from '@bitcoin-portal/bitcoincom-pkg-components/dist/NewsletterV2';

const Subscribe = () => {
  const { messages } = useIntl();

  return (
    <NewsletterV2
      text={{
        title: messages[`home.newsletter.title`],
        subtitle: messages[`home.newsletter.text`],
        button: messages[`home.newsletter.button`],
      }}
      subscribeTo={['email_updates']}
      redirectUrl="https://branch.wallet.bitcoin.com/xafKYCQw3Cb"
    />
  );
};

export default Subscribe;
